import { forwardRef } from 'react';
import { getTheme } from 'utils/themes';
import { Drag } from 'ui/icons';
import { DragHandleContainer } from '../Dashboard.styled';

// type Props = {
//   children: any,
//   /** An additional className. */
//   className: string,
//   /** Toggle className. Should be passed in by DashboardGrid. */
//   dragHandleClass: string,
//   /** Toggle dragging and resizing. */
//   isStatic: boolean,
//   /** Toggle moving of panel. */
//   isDraggable: boolean,
//   /** Toggle risizing of panel. */
//   isResizable: boolean,
//   /** Callback on mouse down. */
//   onMouseDown: () => any,
//   /** Callback on mouse up. */
//   onMouseUp: () => any,
//   /** Callback on touch start. */
//   onTouchStart: () => any,
//   /** Callback on touch end. */
//   onTouchEnd: () => any,
//   /** Toggle drag handle. Panel can only be dragged at handle only or anywhere on panel. */
//   showDragHandle: boolean,
//   /** Display chart table */
//   showChartTable: boolean,
//   /** Additional styles. Passed in by DashboardGrid for positioning. */
//   style: object,
//   /** The dashboard theme. */
//   theme: string,
// };

const DashboardPanel = forwardRef(
  (
    {
      children,
      className,
      dragHandleClass = 'dragHandle',
      showDragHandle = true,
      isDraggable = true,
      isResizable = true,
      isStatic = false,
      onMouseDown,
      onMouseUp,
      onTouchStart,
      onTouchEnd,
      style,
      theme = 'default',
    },
    ref,
  ) => {
    const canDrag = !isStatic && isDraggable;
    const canResize = !isStatic && isResizable;
    const panelClass = `${className} cssDashboardPanel ${
      isStatic ? 'cssDashBoardPanelStatic' : ''
    } ${canDrag ? '' : 'cssCanDrag'} ${canResize ? '' : 'cssNoResize'}`;

    const themeDef = getTheme(theme);
    const panelStyles = {
      backgroundColor: themeDef.panelBackgroundColor,
      boxShadow: themeDef.panelBoxShadow,
      color: themeDef.textColor,
      ...style,
    };

    const { height, width } = style || { height: '0px', width: '0px' };
    const heightValue = parseFloat(height.replace('px', ''));
    const widthValue = parseFloat(width.replace('px', ''));

    return (
      <div
        data-test="dashboard-panel"
        ref={ref}
        className={panelClass}
        style={panelStyles}
        onMouseDown={canDrag ? onMouseDown : undefined}
        onMouseUp={canDrag ? onMouseUp : undefined}
        onTouchStart={canDrag ? onTouchStart : undefined}
        onTouchEnd={canDrag ? onTouchEnd : undefined}
        data-short={heightValue < 300}
        data-extra-short={heightValue < 200}
        data-narrow={widthValue < 460}
        data-extra-narrow={widthValue < 220}
      >
        {children}
        {showDragHandle && (
          <DragHandleContainer data-test="dashboard-handle" data-role="handle">
            <div className={`cssDashboardDragHandle ${dragHandleClass}`}>
              <Drag />
            </div>
          </DragHandleContainer>
        )}
      </div>
    );
  },
);

export default DashboardPanel;
